export default __webpack_public_path__ + "static/UnionPay_logo.png";